import { AccountArrowDownIcon } from './AccountArrowDownIcon';

/**
 * author: Colton Wiscombe
 * id 785965F1-58C0-42F8-9433-9B6A3ACF1AE6
 * name account-arrow-down
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-down.svg
 * tags
 * - Account / User 
 */
export const AccountDownloadIcon = AccountArrowDownIcon;
export default AccountDownloadIcon